var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn border-radius-19 col-12 my-2",attrs:{"data-dismiss":"modal","disabled":_vm.disabled},on:{"click":function($event){return _vm.close()}}},[_vm._v("\n  "+_vm._s(_vm.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }